module.exports = __webpack_public_path__ + "img/brand-17.e055112c.png";